import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AttachmentService } from '../../../models/attachment/attachmentService';
import { LeadsService } from '../../../models/leads/leadsService';
import { Attachment } from '../../../models/attachment/attachment';
import { FileUpload } from '../../../models/attachment/fileUpload';
import { UIHelpers } from '../../../core/ui-helpers';
import { Logging } from '../../../core/logging';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-merchant-attachments',
  templateUrl: './merchant-attachments.component.html',
  standalone: false,
})
export class MerchantAttachmentsComponent {
  @Input() leadId: string | undefined;
  @Input() merchantId: string | undefined;

  fileUploads: FileUpload[] = []; // this is the list of files that are currently selected for upload
  attachmentTypes: ListItem[] = [];
  attachments: Attachment[] = [];
  rolloverId: string | undefined;
  constructor(
    public uploadDialog: MatDialog,
    public router: Router,
    public leadService: LeadsService,
    public attachmentService: AttachmentService,
  ) {}

  ngOnInit() {
    this.attachmentTypes = [
      new ListItem({ id: 'Agreement', name: 'Agreement' }),
      new ListItem({ id: 'Cost analysis', name: 'Cost analysis' }),
      new ListItem({ id: 'Monthly statement', name: 'Monthly statement' }),
      new ListItem({ id: 'Proposal', name: 'Proposal' }),
      new ListItem({ id: 'Staitment analysis', name: 'Staitment analysis' }),
      new ListItem({ id: 'TearVAR', name: 'Tear/VAR' }),
      new ListItem({ id: 'Other', name: 'Other' }),
    ];

    this.refreshDocuments();
  }

  validateUploads(): boolean {
    let isValid = true;

    this.fileUploads.forEach((f) => {
      if (!f.type) {
        isValid = false;
      } else if (f.type == 'Other' && !f.otherType) {
        isValid = false;
      }
    });

    return isValid;
  }

  formatDate(date: string): string {
    return UIHelpers.formatDate(date);
  }

  selectFiles_click() {
    document.getElementById('fileUpload')?.click();
  }

  onDragOver(event: DragEvent): void {
    this.stopDragging(event);
  }

  onDragLeave(event: DragEvent): void {
    this.stopDragging(event);
  }

  onFileDrop(event: DragEvent): void {
    this.stopDragging(event);

    if (event.dataTransfer?.files.length) {
      this.appendFiles(event.dataTransfer.files);
    }
  }

  stopDragging(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const dropZone = event.target as HTMLElement;
    //dropZone.classList.remove('drag-over');
  }

  onFilesSelected(event: any) {
    if (event && event.srcElement.files) {
      this.appendFiles(event.srcElement.files);
    }
  }

  appendFiles(files: FileList) {
    for (var i = 0; i < files.length; i++) {
      this.fileUploads.push(new FileUpload({ file: files[i] }));
    }
  }

  removeUpload_click(index: number) {
    this.fileUploads.splice(index, 1);
  }

  uploadFiles(): void {
    if (this.merchantId) {
      this.attachmentService
        .uploadMerchantAttachments(this.merchantId, this.fileUploads)
        .then(() => {
          this.fileUploads = [];
          this.refreshDocuments();
        });
    }
  }

  refreshDocuments(): Promise<Attachment[]> {
    if (this.merchantId) {
      return this.attachmentService
        .getMerchantAttachments(this.merchantId)
        .then((attachments) => (this.attachments = attachments));
    }
    return Promise.resolve([]);
  }

  showDelete(noteId: string) {
    this.rolloverId = noteId;
  }

  hideDelete() {
    this.rolloverId = undefined;
  }

  btnOpen_click(attachment: Attachment) {
    if (this.merchantId) {
      this.attachmentService.openAttachment(
        attachment.id,
        this.merchantId,
        attachment.filename,
        true,
      );
    }
  }

  btnDownload_click(attachment: Attachment) {
    if (this.merchantId) {
      this.attachmentService.openAttachment(
        attachment.id,
        this.merchantId,
        attachment.filename,
      );
    }
  }

  btnDelete_click(attachment: Attachment) {
    if (this.merchantId) {
      if (
        confirm('Are you sure you want to delete ' + attachment.filename + '?')
      ) {
        this.attachmentService
          .deleteMerchantAttachment(this.merchantId, attachment.id)
          .then(() => {
            this.refreshDocuments();
          });
      }
    }
  }
}
